import restful from '../vuex'
import axios from 'axios'

const state = {
  ...restful.states('dashboard'),
  inforCardData: {},
  pieData: [],
  item_total: 0,
  barData: {},
  sales_by_month: [], // [{x: "珹宝专卖店" y: 26265}]
  shops_summary: [], // [{"shop_name":"珹宝专卖店","sales":828631,"customers_count":90,"products_count":740}]
  sales_payment_methods: [], // [{"x":"现金收款","y":793065},{"x":"支付宝-线下收款","y":4575},{"x":"银行卡收款","y":15243},{"x":"支付宝-线上收款","y":148},{"x":"微信-线下收款","y":13024},{"x":"微信-线上收款","y":225},{"x":"储值卡收款","y":1886},{"x":"现金收款","y":25},{"x":"美团-线下付款","y":438}]
  orders_count_by_month: [], // [{"x":"珹宝专卖店","y":173}]
  sales_trend_by_month: [], // [{"x":"2020-06","y":65778},{"x":"2020-07","y":10900},{"x":"2020-08","y":26881},{"x":"2020-09","y":6647},{"x":"2020-10","y":16726},{"x":"2020-11","y":26265}]
  shops_count: { value: 0 },
  today_sales_count: { value: 0 },
  today_orders_count: { value: 0 },
  shops_maps: {}
}

const getters = {
  ...restful.getters('dashboard'),
  pieData: (state) => state.pieData,
  barData: (state) => state.barData,
  inforCardData: (state) => state.inforCardData,
  item_total: (state) => state.item_total
}

const actions = {
  ...restful.actions('dashboards'),
  async dashboardCount ({ commit }) {
    const response = await axios.get('dashboards')
    const result = [
      {
        title: '今日订单数',
        icon: 'ios-reorder',
        count: response.data.today,
        color: '#2d8cf0'
      },
      {
        title: '会员数',
        icon: 'md-locate',
        count: response.data.fresh_customers,
        color: '#19be6b'
      },
      {
        title: '会员总充值',
        icon: 'md-map',
        count: response.data.fresh_customer_charges,
        color: '#9A66E4'
      },
      {
        title: '商品数',
        icon: 'md-menu',
        count: response.data.fresh_products,
        color: '#ff9900'
      },
      {
        title: '总订单数',
        icon: 'md-reorder',
        count: response.data.total_orders,
        color: '#E46CBB'
      },
      {
        title: '供应商数',
        icon: 'md-chatbubbles',
        count: response.data.fresh_suppliers,
        color: '#E46CBB'
      },
      {
        title: '消息数',
        icon: 'md-map',
        count: response.data.fresh_messages,
        color: '#9A66E4'
      }
    ]
    commit('pieData', response.data.orders)
    commit('inforCardData', result)
    commit('barData', response.data.last_7_days_orders)
    commit('item_total', response.data.item_total)
  },
  fetchDashBoardData ({ commit }) {
    axios.get('dashboards').then(res => {
      console.log('res', res)
      commit('merge', res.data)
    })
  }
}

const mutations = {
  ...restful.mutations('dashboard'),
  pieData (state, pieData) {
    state.pieData = pieData
  },
  barData (state, barData) {
    state.barData = barData
  },
  inforCardData (state, inforCardData) {
    state.inforCardData = inforCardData
  },
  item_total (state, item_total) {
    state.item_total = item_total
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
